import styles from './FooterSocialIcons.module.scss';
import { SocialIcons, IconMap } from './types';
import { CatIconFacebook } from '@blocks-react/components/Icons/Facebook';
import { CatIconSocialLinkedin } from '@blocks-react/components/Icons/SocialLinkedin';
import { CatIconSocialYoutube } from '@blocks-react/components/Icons/SocialYoutube';
import { CatIconSocialInstagram } from '@blocks-react/components/Icons/SocialInstagram';
import { CatIconSocialX } from '@blocks-react/components/Icons/SocialX';

export const FooterSocialIcons = ({ socialId, socialName }: SocialIcons) => {
  const iconMap: IconMap = {
    catSocialFacebook: CatIconFacebook,
    catSocialYouTube: CatIconSocialYoutube,
    catSocialInstagram: CatIconSocialInstagram,
    catSocialLinkedIn: CatIconSocialLinkedin,
    catSocialX: CatIconSocialX,
    catSocialTwitter: CatIconSocialX,
  };

  const IconComponent = iconMap[socialId];

  return (
    <div className={styles['footer_pcclink-list-item']}>
      {IconComponent ? (
        <IconComponent
          className={styles['footer_pcclink-list-item__icon']}
          data-testid="footer_social_icon"
        />
      ) : null}
      {socialId === 'catSocialTwitter' ? 'X' : socialName}
    </div>
  );
};
